module.exports = __webpack_public_path__ + "static/media/2.349b43c1.jpg";